import React, { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { FiSearch } from 'react-icons/fi';
import getFormatedDate from '../../utils/getFormatedDate';

import api from '../../services/api';
import getParamsUri from '../../utils/getParamsUri';

interface Edition {
  id: number;
  date: Date;
  name: string;
}

interface EditionParams {
  date: Date;
}

const Editions: React.FC = () => {
  const [editions, setEditions] = useState<Edition[]>();

  const location = useLocation();

  const handleListEditions = useCallback(() => {
    const params = getParamsUri<EditionParams>(location.search);

    api
      .get<Edition[]>('editions', {
        params,
      })
      .then(response => {
        setEditions(response.data);
      });
  }, [location.search]);

  useEffect(() => {
    handleListEditions();
  }, [handleListEditions]); // TODO: adicionar parametro de URL, caso haja alteração de parametro na URL

  return (
    <>
      <h5>EDIÇÕES</h5>

      <div className="p-3" />

      {editions && editions.length ? (
        <div className="table-responsive">
          <table className="table" width="100%">
            <colgroup>
              <col width="80" />
              <col width="" />
            </colgroup>
            <thead>
              <tr>
                <th>DATA</th>
                <th>NOME</th>
                <th> </th>
              </tr>
            </thead>
            <tbody>
              {editions.map(edition => (
                <tr key={edition.id}>
                  <td>
                    <Link to={`search/?edition_id=${edition.id}`}>
                      {getFormatedDate(edition.date.toString())}
                    </Link>
                  </td>
                  <td>
                    <Link to={`search/?edition_id=${edition.id}`}>
                      {edition.name}
                    </Link>
                  </td>
                  <td className="text-right">
                    <Link to={`search/?edition_id=${edition.id}`}>
                      <FiSearch size={18} />
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div>
          {editions && editions.length === 0 ? (
            <div>Nenhum resultado encontrado.</div>
          ) : (
            <div>Pesquisando, aguarde...</div>
          )}
        </div>
      )}

      <div className="d-flex justify-content-center">
        <Link className="btn btn-primary bottom" to="/">
          REALIZAR NOVA BUSCA
        </Link>
      </div>
    </>
  );
};

export default Editions;
